import React, { memo, useRef, FC } from 'react';
import LatestArticle from '@/components/common/latest-article';
import classNames from 'classnames';
import styles from '@/styles/components/blog-swiper.module.scss';
import { XyzTransitionGroup } from '@animxyz/react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper';
import Image from 'next/image';

type Props = {
  title?: string;
  homePage?: any;
  isMultiple?: boolean;
}
const BlogSwiper: FC<Props> = memo((props) => {

  const latestArticles = props.homePage?.latestArticles || [];

  return (
    <div className={styles.Swiper_Article_Wrap}>
      <div className={classNames(props.isMultiple ? styles.MuiContainer_root : '', styles.MuiContainer_maxWidthXl, props.isMultiple ? styles.Latest_Article_Container : styles.Latest_Article_Container_Less)}>
        {
          props.isMultiple ? <div className={classNames('swiper-button-next', styles.Custom_Button_Next)}>
            <Image src="/blog/icon/Right.svg" alt={''} width={13} height={21}/>
          </div> : ''
        }
        <XyzTransitionGroup appearVisible xyz=" delay-1 fade-100% down-2">
          <h3 className={classNames(styles.MuiContainer_root, styles.MuiContainer_maxWidthXl, styles.Title)}>
            {props.homePage?.body?.find((item: any) => item.latest_blog_list)?.latest_blog_list.title || props.title}
          </h3>
          {
            props.isMultiple ? <div className={styles.Carousel_Wrap}>
              <div className={classNames('swiper-button-prev', styles.Custom_Button_Prev)}>
                <Image src="/blog/icon/Left.svg" alt={''} width={13} height={21}/>
              </div>
              <Swiper
                slidesPerView={3}
                spaceBetween={24}
                modules={[Navigation]}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                loop={true}
                className={styles.Carousel_Item_Wrap}
              >
                {
                  latestArticles.map((v: any, k: any) => (
                    v.created_at ?
                      <SwiperSlide key={v.uid} className={styles.Carousel_Item}>
                        <div>
                          <LatestArticle className={styles.Latest_Article} isHide={true} latestArticle={v} lazyImage={true}/>
                        </div>
                      </SwiperSlide> : ''
                  ))
                }
              </Swiper>
              <div className={classNames('swiper-button-next')}>
                <Image src="/blog/icon/Right.svg" alt={''} width={13} height={21}/>
              </div>
            </div> : <div className={styles.Carousel_Wrap_Less}>
              <Swiper
                modules={[FreeMode]}
                slidesPerView={'auto'}
                freeMode={true}
              >
                {
                  latestArticles.map((v: any, k: any) => (
                    v.created_at ?
                      <SwiperSlide key={v.uid} className={styles.Carousel_Item}>
                        <div>
                          <LatestArticle className={styles.Latest_Article} isHide={true} latestArticle={v} lazyImage={true}/>
                        </div>
                      </SwiperSlide> : ''
                  ))
                }
              </Swiper>
            </div>
          }

          <div className={styles.Carousel_Mobile_Wrap}>
            <Swiper
              modules={[FreeMode]}
              slidesPerView={'auto'}
              spaceBetween={8}
              freeMode={true}
            >
              {
                latestArticles.map((v: any, k: any) => (
                  v.created_at ?
                  <SwiperSlide key={v.uid} className={styles.Carousel_Item}>
                    <div>
                      <LatestArticle className={styles.Latest_Article} isHide={true} latestArticle={v} lazyImage={true}/>
                    </div>
                  </SwiperSlide> : ''
                ))
              }
            </Swiper>
          </div>
        </XyzTransitionGroup>
      </div>
    </div>
  )
})

export default BlogSwiper;
